export default __webpack_public_path__ + "static/media/pic7.12f3a029.jpg";